import { useState } from "react";
import { useScrollReveal } from "../useScrollReveal";

function ProjectCard({ project, index }) {
  const [hovered, setHovered] = useState(false);
  const [ref, visible] = useScrollReveal(0.1);

  return (
    <div
      ref={ref}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: "var(--off-white)", border: "1px solid var(--border)",
        borderRadius: "var(--radius)", padding: "2rem",
        transform: hovered ? "translateY(-4px)" : visible ? "none" : "translateY(24px)",
        boxShadow: hovered ? "0 12px 40px rgba(0,0,0,0.07)" : "none",
        opacity: visible ? 1 : 0,
        transition: "transform 0.3s ease, box-shadow 0.3s ease, opacity 0.6s ease",
        transitionDelay: visible ? `${index * 0.08}s` : "0s",
        display: "flex", flexDirection: "column",
      }}
    >
      <span style={{
        display: "inline-block", background: "var(--white)", border: "1px solid var(--border)",
        borderRadius: "999px", padding: "0.2rem 0.75rem",
        fontSize: "0.73rem", color: "var(--text-muted)", marginBottom: "1rem", letterSpacing: "0.04em",
        width: "fit-content",
      }}>{project.tag}</span>

      <h3 style={{ fontFamily: "var(--serif)", fontSize: "1.4rem", lineHeight: 1.2, marginBottom: "0.75rem" }}>
        {project.title}
      </h3>
      <p style={{ fontSize: "0.9rem", color: "var(--text-secondary)", lineHeight: 1.65, fontWeight: 300, marginBottom: "1.5rem", flex: 1 }}>
        {project.desc}
      </p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "0.4rem", marginBottom: "1.5rem" }}>
        {project.stack.map((t) => (
          <span key={t} style={{ background: "var(--light-gray)", borderRadius: 4, padding: "0.15rem 0.55rem", fontSize: "0.73rem", color: "var(--text-secondary)" }}>{t}</span>
        ))}
      </div>
      <a href={project.link} style={{
        display: "inline-flex", alignItems: "center", gap: "0.4rem",
        fontSize: "0.85rem", fontWeight: 500, color: "var(--text-main)",
        borderBottom: "1px solid var(--text-main)", paddingBottom: 1,
        width: "fit-content", transition: "opacity 0.2s",
        opacity: hovered ? 0.55 : 1,
      }}>View case study →</a>
    </div>
  );
}

export default function Projects({ data }) {
  return (
    <section id="work" style={{ padding: "6rem 0" }}>
      <div className="section-inner">
        <div className="section-label">Work</div>
        <h2 className="section-title">Selected <em>projects</em></h2>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "1.5rem" }}>
          {data.projects.map((p, i) => <ProjectCard key={p.title} project={p} index={i} />)}
        </div>
      </div>
    </section>
  );
}
